var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLinkedin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.683 8H4.18v8h2.503zM15.7 11.71V16h-2.502v-4c0-1.051-.126-1.903-1.351-1.903s-1.35.854-1.35 1.904V16H7.994V8h2.503v1.143c.377-.83 1.09-1.357 2.407-1.357q.153 0 .294.01c2.26.134 2.503 1.834 2.503 3.914M6.867 5.432a1.433 1.433 0 1 0-2.863.002 1.433 1.433 0 0 0 2.86-.002z"
  })));
};
export default SvgIcLinkedin;